import { ViewMode } from "./interaction-mode/view-mode";
import { MeasureMode } from "./interaction-mode/measure-mode";
import { ClippingMode } from "./interaction-mode/clipping-mode";
import { EditorMode } from "./interaction-mode/editor-mode";
import { CustomMode } from "./interaction-mode/custom-mode";
import { AbstractInteractionMode } from "./interaction-mode/abstract-interaction-mode";
import { BoundingBoxMode } from "./interaction-mode/bounding-box-mode";
import { GeoReferencerMode } from "./interaction-mode/georeferencer-mode";
import { LocationPickerMode } from "./interaction-mode/location-picker-mode";
import { DrawerMode } from "./interaction-mode/drawer-mode";
import PrintControl from "./controllers/print-control";
// @ts-ignore
import MapFormControl from "../../components/map/controls/MapFormControl.vue";
// @ts-ignore
import MapCarouselControl from "../../components/map/controls/MapCarouselControl.vue";


// @ts-ignore
import MapFormControlConfiguration from "../../components/map/controls/configuration/MapFormControlConfiguration.vue";

// @ts-ignore
import MapCarouselControlConfiguration from "../../components/map/controls/configuration/MapCarouselControlConfiguration.vue";
// @ts-ignore
import MapGeocoderControlConfiguration from "../../components/map/controls/configuration/MapGeocoderControlConfiguration.vue";
// @ts-ignore
import MapButtomControlConfiguration from "../../components/map/controls/configuration/MapButtonControlConfiguration.vue"
import { BlankMode } from "./interaction-mode/blank-mode";
// @ts-ignore
import MapGeocoderControl from "../../components/map/controls/MapGeocoderControl.vue";
// @ts-ignore
import MapButton from "../../components/map/MapButton.vue";
// @ts-ignore
import MapCoordinatesControl from "../../components/map/controls/MapCoordinatesControl.vue";
// @ts-ignore
import MapOrientationControl from "../../components/map/controls/MapOrientationControl.vue";
// @ts-ignore
import MapLegendControl from "../../components/map/controls/MapLegendToggleControl.vue";
// @ts-ignore
import MapZoomControl from "../../components/map/controls/MapZoomControl.vue";
// @ts-ignore
import MapStateControl from "../../components/map/controls/MapStateControl.vue";
import {InteractionDefinition} from "./interaction/abstract-interaction";

export class MapControlDefinition {
  constructor(
      public identifier: string,
      //@ts-ignore
      public component: typeof mapboxgl.IControl | typeof mapboxgl.Control,
      public configuration: any | undefined = undefined
  ) {
  }
}

export class MapSettingsRegistry {
  private static _modes: (typeof AbstractInteractionMode)[] = [
    ViewMode,
    MeasureMode,
    ClippingMode,
    EditorMode,
    CustomMode,
    BoundingBoxMode,
    GeoReferencerMode,
    LocationPickerMode,
    DrawerMode,
    BlankMode,
  ];
  private static _slots: string[] = ['top', 'bottom', 'top-left', 'top-right', 'bottom-left', 'bottom-right'];
  private static _controlSlots: string[] = ['top', 'bottom', 'top-left', 'top-right', 'bottom-left', 'bottom-right'];
  private static _addons: string[] = ['info', 'layerInfo', 'analytics','hoverInfo', '3d', 'legend', 'specifications', 'sky'];

  private static _controls: MapControlDefinition[] = [
    new MapControlDefinition('form', MapFormControl, MapFormControlConfiguration),
    new MapControlDefinition('print', PrintControl),
    new MapControlDefinition('carousel', MapCarouselControl, MapCarouselControlConfiguration),
    new MapControlDefinition('geocoder', MapGeocoderControl, MapGeocoderControlConfiguration),
    new MapControlDefinition('button', MapButton, MapButtomControlConfiguration),
    new MapControlDefinition('coordinates', MapCoordinatesControl),
    new MapControlDefinition('orientation', MapOrientationControl),
    new MapControlDefinition('zoom', MapZoomControl),
    new MapControlDefinition('legend', MapLegendControl),
    new MapControlDefinition('spinner', MapStateControl),
  ];

  static getModes(identifiers: string[] | undefined = undefined): (typeof AbstractInteractionMode)[] {
    if (identifiers) {
      return this._modes.filter(mode => identifiers.indexOf(mode.identifier) >= 0);
    }

    return this._modes;
  }

  static getInteractions(mode: string): (typeof InteractionDefinition)[] {
    if(mode){
      return this._modes.find(x=> x.identifier === mode)?.interactions
    }
    return [];

  }

  static getControls(identifiers: string[] | undefined = undefined): MapControlDefinition[] {
    if (identifiers) {
      return this._controls.filter(definition => identifiers.indexOf(definition.identifier) >= 0);
    }

    return this._controls;
  }

  static getControl(identifier: string): MapControlDefinition {
    return this._controls.find(controlDefinition => controlDefinition.identifier == identifier);
  }

  static getMode(identifier): (typeof AbstractInteractionMode) | undefined {
    let modes = this._modes.filter(mode => mode.identifier === identifier);
    return modes.length > 0 ? modes[0] : undefined;
  }

  static getSlots(): string[] {
    return this._slots;
  }

  static getControlSlots(): string[] {
    return this._controlSlots;
  }

  static getAddons(): string[] {
    return this._addons;
  }
}
